import { useCallback } from 'react';

import { useTranslation } from '@lyearn/i18n';
import AsyncSelect from '@/components/AsyncSelect';
import { ThemeEntityConfig } from '@/components/FilterManager/EntityFilter/entity/theme';
import { NewFilterOption } from '@/components/FilterNew/types';
import { getSelectOptionLabel } from '@/components/Form/components/Select/getOptionLabel';
import { Maybe } from '@/types/schema';

interface ThemeAsyncSelectProps {
  value: Maybe<string[]> | undefined;
  onChange: (value: Maybe<string[]>) => void;
  disabled?: boolean;
  error?: boolean;
}

const isOptionEqualToValue = (option: NewFilterOption, value: NewFilterOption) => {
  return option.value === value.value;
};

const useOptionsQuery = (params: { searchText: string }) => {
  const { searchText } = params;
  const { fetching, error, groups } = ThemeEntityConfig.useOptionsQuery({ searchText });

  return { fetching, error, data: groups[0]?.options || [] };
};

const ThemeAsyncSelect = (props: ThemeAsyncSelectProps) => {
  const { t } = useTranslation();
  const { value, onChange, disabled, error } = props;
  const { selectedOptions } = ThemeEntityConfig.useFilterValues({ value: value || [] });

  const onThemeChange = useCallback(
    (theme: NewFilterOption) => {
      onChange([theme.value]);
    },
    [onChange],
  );

  return (
    <AsyncSelect
      disableClearable
      disabled={disabled}
      error={error}
      getOptionLabel={getSelectOptionLabel}
      isOptionEqualToValue={isOptionEqualToValue}
      placeholder={t('UserSurvey:Creator.SelectTheme')}
      size="medium"
      useOptionsQuery={useOptionsQuery}
      value={selectedOptions[0]}
      onChange={onThemeChange}
    />
  );
};

export default ThemeAsyncSelect;
